<template>
   <div class="print-screen">
    <div @click.stop class="tool-box" v-show="flag">
                    <i :class="{active:currentTool=='pencil'}" @click="changeTool('pencil')" class="iconfont icon-qianbi"></i>
                    <i :class="{active:currentTool=='rectangle'}" @click="changeTool('rectangle')" class="iconfont icon-duoxuanweixuanzhong"></i>
                    <i :class="{active:currentTool=='circle'}" @click="changeTool('circle')" class="iconfont icon-weixuanzhongyuanquan"></i>
                    <i :class="{active:currentTool=='linestring'}" @click="changeTool('linestring')" class="iconfont icon-line"></i>
                    <!-- <i :class="{active:currentTool=='rubber'}" @click="changeTool('rubber')" class="iconfont icon-rubber-full"></i> -->
                    <i class="iconfont icon-guanbi" @click="exit"></i>
                    <i @click="download" class="iconfont icon-gou"></i>
                </div>
    <el-tooltip class="item" effect="dark" content="截取页面" placement="top-start">
        <i class="iconfont icon-jiequpingmu" @click="printScreen"></i>
    </el-tooltip>
        <div id="selectionOverlay">
            <div id="selectionBox">
            </div>
            <div v-show="isSelecting" class="selection-info" id="selectionInfo"></div>
        </div>
   </div>
</template>

<script>
export default {
    data(){
        return {
            selectionOverlay:null,
            selectionBox:null,
            selectionInfo:null,
            currentScreenshot:null,
            isSelecting:false,
            startX:'',
            startY:'',
            endX:'',
            endY:'',
            currentTool:'',
            isDrawing:false,
            lastX:0,
            lastY:0,
            canvas:null,
            ctx:null,
            /**预览画布 */
            previewCanvas:null,
            /**预览上下文 */
            previewCtx:null,
            flag:false,
            isDragging:false,
            currentEllipse:{
                startX:0,
                startY:0
            },
            dragOffset:{
                x:0,
                y:0
            }
        }
    },
    methods:{
         // 绘制单个椭圆
        drawEllipse(ellipse,ctx) {
            // 设置样式
            ctx.strokeStyle = 'red'
            ctx.lineWidth = '3';
            // 计算椭圆中心点和半径
            const centerX = ellipse.x + ellipse.width / 2;
            const centerY = ellipse.y + ellipse.height / 2;
            const radiusX = Math.abs(ellipse.width) / 2;
            const radiusY = Math.abs(ellipse.height) / 2;
            
            // 绘制椭圆
            ctx.beginPath();
            ctx.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, 2 * Math.PI);
            ctx.stroke();
            
            // // 如果椭圆被选中，绘制控制点
            // if (isSelected) {
            //     drawControlPoints(ellipse);
            // }
            
            // this.previewCanvas.restore();
        },
          // 绘制过程
        drawCircle(e) {
            const rect = this.previewCanvas.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            // 绘制新椭圆
            this.currentEllipse.width = x - this.currentEllipse.startX;
            this.currentEllipse.height = y - this.currentEllipse.startY;
            this.drawEllipse(this.currentEllipse,this.previewCtx);
        },
        // 停止绘制
        // stopDrawing() {
        //     if (Math.abs(currentEllipse.width) > 5 && Math.abs(currentEllipse.height) > 5) {
        //             saveToHistory();
        //             ellipses.push({...currentEllipse});
        //         }
            
        //     // 重置状态
        //     isDrawing = false;
        //     isDragging = false;
        //     isResizing = false;
        //     currentEllipse = null;
        //     selectedEllipseIndex = -1;
            
        //     // 重绘画布
        //     clearCanvas();
        //     drawGrid();
        //     drawAllEllipses();
        // },
        /**开始拖拽 */
        startDrag(e){
            this.isDragging=true;
            // 计算鼠标位置与弹窗位置的偏移
            const rect = this.canvas.getBoundingClientRect();
            this.dragOffset.x = e.clientX - rect.left;
            this.dragOffset.y = e.clientY - rect.top;
            e.preventDefault();
        },
        /**拖拽中 */
        draging(e){
            if (!this.isDragging||!this.canvas||this.currentTool) return;
            // 计算新位置
            let newX = e.clientX - this.dragOffset.x;
            let newY = e.clientY - this.dragOffset.y;
            // 限制在视口范围内
            const maxX = window.innerWidth - this.canvas.offsetWidth;
            const maxY = window.innerHeight - this.canvas.offsetHeight;
            newX = Math.max(0, Math.min(newX, maxX));
            newY = Math.max(0, Math.min(newY, maxY));
            // 应用新位置
            this.canvas.style.left = `${newX}px`;
            this.canvas.style.top = `${newY}px`;
            this.previewCanvas.style.left = `${newX}px`;
            this.previewCanvas.style.top = `${newY}px`;
            let dom=document.querySelector('.tool-box');
            dom.style.left=`${newX+this.canvas.offsetWidth-170}px`;
            dom.style.top=`${newY+this.canvas.offsetHeight}px`;
        },
        /**拖拽结束 */
        endDrag(){
            this.isDragging=false;
        },
        bindStartDrag(e){
            (()=>{
                this.startDrag(e);
            })();
        },
        bindDraging(e){
            (()=>{
                this.draging(e);
            })();
        },
        bindEndDrag(e){
            (()=>{
                this.endDrag(e);
            })();
        },
        // 开始绘制
        startDrawing(e) {
            this.isDrawing = true;
            this.lastX=e.offsetX;
            this.lastY=e.offsetY;
            if(this.currentTool=='circle'){
                const rect = this.previewCanvas.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                this.currentEllipse.startX=x;
                this.currentEllipse.startY=y;
                this.currentEllipse.x=x;
                this.currentEllipse.y=y;
            }
        },
        // 绘制中
        draw(e) {
            if (!this.isDrawing) return;
            // 清除预览画布
            if(this.currentTool !== 'pencil'){
                this.previewCtx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
            this.previewCtx.lineJoin = 'round';
            this.previewCtx.lineCap = 'round';
            this.ctx.lineJoin = 'round';
            this.ctx.lineCap = 'round';
            if (this.currentTool === 'pencil') {
                this.ctx.strokeStyle = 'red';
                this.ctx.lineWidth = '3';
                this.ctx.beginPath();
                this.ctx.moveTo(this.lastX, this.lastY);
                this.ctx.lineTo(e.offsetX, e.offsetY);
                this.ctx.stroke();
                this.lastX=e.offsetX;
                this.lastY=e.offsetY;
            }else if (this.currentTool === 'rubber') {
                this.previewCtx.strokeStyle = '#ffffff';
                this.previewCtx.lineWidth = 3 * 2;
                this.previewCtx.beginPath();
                this.previewCtx.moveTo(this.lastX, this.lastY);
                this.previewCtx.lineTo(e.offsetX, e.offsetY);
                this.previewCtx.stroke();
                this.lastX=e.offsetX;
                this.lastY=e.offsetY;
            }else if(this.currentTool === 'linestring'){
                this.previewCtx.strokeStyle = 'red';
                this.previewCtx.lineWidth = '3';
                this.previewCtx.beginPath();
                this.previewCtx.moveTo(this.lastX, this.lastY);
                this.previewCtx.lineTo(e.offsetX, e.offsetY);
                this.previewCtx.stroke();
            }else if(this.currentTool === 'rectangle'){
                this.previewCtx.strokeStyle = 'red';
                this.previewCtx.lineWidth = '3';
                const width = e.offsetX - this.lastX;
                const height = e.offsetY - this.lastY;
                this.previewCtx.strokeRect(this.lastX, this.lastY, width, height);
            }else if(this.currentTool === 'circle'){
                this.drawCircle(e);
                // this.previewCtx.strokeStyle = 'red';
                // this.previewCtx.lineWidth = '3';
                // const radius = Math.sqrt(
                //     Math.pow(e.offsetX - this.lastX, 2) + Math.pow(e.offsetY - this.lastY, 2)
                // );
                // this.previewCtx.beginPath();
                // this.previewCtx.arc(this.lastX, this.lastY, radius, 0, Math.PI * 2);
                // this.previewCtx.stroke();
            }
            // 其他工具（直线、矩形、圆形）在停止绘制时完成
        },
        // 停止绘制
        stopDrawing(e) {
            if (!this.isDrawing) return;
            this.isDrawing = false;
            if (this.currentTool === 'pencil') {
                this.ctx.strokeStyle = 'red';
                this.ctx.lineWidth = '3';
                this.ctx.beginPath();
                this.ctx.moveTo(this.lastX, this.lastY);
                this.ctx.lineTo(e.offsetX, e.offsetY);
                this.ctx.stroke();
                this.lastX=e.offsetX;
                this.lastY=e.offsetY;
            }else if (this.currentTool === 'rubber') {
                this.ctx.strokeStyle = '#ffffff';
                this.ctx.lineWidth = 3 * 2;
                this.ctx.beginPath();
                this.ctx.moveTo(this.lastX, this.lastY);
                this.ctx.lineTo(e.offsetX, e.offsetY);
                this.ctx.stroke();
                this.lastX=e.offsetX;
                this.lastY=e.offsetY;
            }else if (this.currentTool === 'linestring') {
                // saveCanvasState();
                this.ctx.strokeStyle = 'red';
                this.ctx.lineWidth = '3';
                this.ctx.beginPath();
                this.ctx.moveTo(this.lastX, this.lastY);
                this.ctx.lineTo(e.offsetX, e.offsetY);
                this.ctx.stroke();
            }
            else if (this.currentTool === 'rectangle') {
                // saveCanvasState();
                this.ctx.strokeStyle = 'red';
                this.ctx.lineWidth = '3';
                const width = e.offsetX - this.lastX;
                const height = e.offsetY - this.lastY;
                this.ctx.strokeRect(this.lastX, this.lastY, width, height);
            }
            else if (this.currentTool === 'circle') {
                // saveCanvasState();
                // this.ctx.strokeStyle = 'red';
                // this.ctx.lineWidth = '3';
                // const radius = Math.sqrt(
                //     Math.pow(e.offsetX - this.lastX, 2) + Math.pow(e.offsetY - this.lastY, 2)
                // );
                // this.ctx.beginPath();
                // this.ctx.arc(this.lastX, this.lastY, radius, 0, Math.PI * 2);
                // this.ctx.stroke();
                this.drawEllipse(this.currentEllipse,this.ctx);
            }
        },
        bindStart(e){
            (()=>{
                this.startDrawing(e);
            })();
        },
        binding(e){
            (()=>{
                this.draw(e);
            })();
        },
        bindEnd(e){
            (()=>{
                this.stopDrawing(e);
            })();
        },
        startListener(){
            this.previewCanvas.addEventListener('mousedown', this.bindStart);
            this.previewCanvas.addEventListener('mousemove', this.binding);
            this.previewCanvas.addEventListener('mouseup', this.bindEnd);
            this.previewCanvas.addEventListener('mouseout', this.bindEnd);
        },
        endListener(){
            if(!this.previewCanvas)return;
            this.previewCanvas.removeEventListener('mousedown', this.bindStart);
            this.previewCanvas.removeEventListener('mousemove', this.binding);
            this.previewCanvas.removeEventListener('mouseup', this.bindEnd);
            this.previewCanvas.removeEventListener('mouseout', this.bindEnd);
        },
        changeTool(type){
            this.currentTool=(type==this.currentTool?'':type);
            if(!this.currentTool){
                this.canvas&&(this.canvas.style.zIndex=101);
            }else{
                this.canvas&&(this.canvas.style.zIndex=99);
            }
            this.startListener();
        },
        printScreen(){
            // navigator.mediaDevices.getDisplayMedia({ video: true }).then(res=>{
            //     console.log(res,'lkkk')
            // })
            document.body.classList.add('animation-paused');
            this.selectionOverlay.style.display = 'block';
            this.isSelecting = false;
            this.selectionBox.style.display = 'none';
            this.selectionOverlay.style['clip-path']='none';
            this.selectionOverlay.addEventListener('mousedown',this.bindMousedown);
            this.selectionOverlay.addEventListener('mousemove',this.bindMousemove);
            this.selectionOverlay.addEventListener('mouseup',this.bindMouseup);
            this.selectionOverlay.addEventListener('mouseleave',this.bindMouseup);
        },
        /**下载图片 */
        download(){
            // this.save();
            this.currentScreenshot=this.canvas.toDataURL('image/png');
            const link=document.createElement('a');
            document.body.classList.remove('animation-paused');
            link.setAttribute('download',new Date().getTime())
            link.setAttribute('href',this.currentScreenshot);
            link.click();
            this.selectionOverlay.style.display = 'none';
            this.selectionOverlay.style['clip-path']='none';
        },
        removeLister(){
            if(!this.selectionOverlay)return;
            this.selectionOverlay.removeEventListener('mousedown',this.bindMousedown);
            this.selectionOverlay.removeEventListener('mousemove',this.bindMousemove);
            this.selectionOverlay.removeEventListener('mouseup',this.bindMouseup);
            this.selectionOverlay.removeEventListener('mouseleave',this.bindMouseup);
        },
         // 更新选择区域信息
        updateSelectionInfo(left, top, width, height) {
                this.selectionInfo.textContent = `${width} × ${height}`;
                this.selectionInfo.style.left = (left + width + 10) + 'px';
                this.selectionInfo.style.top = (top - 30) + 'px';
        },
        bindMousedown(e){
          (()=>{
            this.mousedown(e);
          })();
        },
        bindMousemove(e){
            (()=>{
                this.mousemove(e);
            })();
        },
        bindMouseup(e){
            (()=>{
                this.mouseup(e);
            })();
        },
        mousedown(e){
                this.isSelecting = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                this.selectionBox.style.left = this.startX + 'px';
                this.selectionBox.style.top = this.startY + 'px';
                this.selectionBox.style.width = '0px';
                this.selectionBox.style.height = '0px';
                this.selectionBox.style.display = 'block';
                this.updateSelectionInfo(this.startX, this.startY, 0, 0);
        },
        mousemove(e){
            if (!this.isSelecting) return;
                this.endX = e.clientX;
                this.endY = e.clientY;
                const left = Math.min(this.startX, this.endX);
                const top = Math.min(this.startY,this.endY);
                const width = Math.abs(this.endX - this.startX);
                const height = Math.abs(this.endY - this.startY);
                this.selectionBox.style.left = left + 'px';
                this.selectionBox.style.top = top + 'px';
                this.selectionBox.style.width = width + 'px';
                this.selectionBox.style.height = height + 'px';
                this.updateSelectionInfo(left, top, width, height);
        },
        mouseup(e){
            if (!this.isSelecting) return;
                this.isSelecting = false;
                // this.selectionOverlay.style.display = 'none';
                const left = Math.min(this.startX, this.endX)+2;
                const top = Math.min(this.startY, this.endY)+2;
                const width = Math.abs(this.endX - this.startX)-4;
                const height = Math.abs(this.endY - this.startY)-4;
                // 确保选择区域有效
                if (width < 10 || height < 10) {
                    return;
                }
                let dom=document.querySelector('.tool-box');
                dom.style.left=`${left+width-170}px`;
                dom.style.top=`${top+height}px`;
                this.selectionOverlay.style['clip-path']=`polygon(0 0, 0% 100%,${left}px 100%,${left}px ${top}px,${left+width}px ${top}px,${left+width}px ${top+height}px,${left}px ${top+height}px,${left}px 100%,100% 100%, 100% 0%)`;
                this.flag=true;
                this.removeLister();
                this.save();
        },
        /**创建预览画布 */
        createPreviewDom(params){
            this.previewCanvas=document.createElement('canvas');
            this.previewCtx=this.previewCanvas.getContext('2d');
            this.previewCanvas.width = params.width;
            this.previewCanvas.height = params.height;
            this.previewCanvas.style.position='fixed';
            this.previewCanvas.style.left=`${params.left}px`;
            this.previewCanvas.style.top=`${params.top}px`;
            this.previewCanvas.style.zIndex='100';
            document.body.appendChild(this.previewCanvas);
        },
        save(){
                const left = Math.min(this.startX, this.endX);
                const top = Math.min(this.startY,this.endY);
                const width = Math.abs(this.endX - this.startX);
                const height = Math.abs(this.endY - this.startY);
                // 截取整个页面，然后裁剪选定区域
                html2canvas(document.body, {
                    x: left,   // 裁剪起点X
                    y: top,   // 裁剪起点Y
                    width: width,
                    height: height,
                    useCORS: true,   // 允许跨域
                    allowTaint: false,
                    proxy:process.env.VUE_APP_OSS_IP,
                    scale: 1,
                    backgroundColor: null, 
                    windowWidth: document.body.clientWidth,
                    windowHeight: document.body.clientHeight
                    // useCORS: true,
                    // allowTaint: true,
                    // scale: 1
                }).then(function(canvas) {
                    // 创建临时canvas用于裁剪
                    const tempCanvas = document.createElement('canvas');
                    const tempCtx = tempCanvas.getContext('2d');
                    this.canvas=tempCanvas;
                    this.ctx=tempCtx;
                    tempCanvas.width = width;
                    tempCanvas.height = height;
                    tempCanvas.style.position='fixed';
                    tempCanvas.style.left=`${left}px`;
                    tempCanvas.style.top=`${top}px`;
                    tempCanvas.style.zIndex='101';
                    document.body.appendChild(tempCanvas);
                    this.createPreviewDom({width,height,left,top});
                    this.canvas.addEventListener('mousedown',this.bindStartDrag);
                    this.canvas.addEventListener('mousemove',this.bindDraging);
                    this.canvas.addEventListener('mouseup',this.bindEndDrag);
                    // 从全屏截图中裁剪选定区域
                    tempCtx.drawImage(
                        canvas, 
                        0,
                        0
                    );
                    this.currentScreenshot=tempCanvas.toDataURL('image/png');
                    this.flag=true;
                    this.selectionOverlay.style.display = 'none';
                    this.selectionOverlay.style['clip-path']='none';
                }.bind(this));
        },
        /**退出截屏 */
        exitScreen(event){
             // 检查按下的键是否是ESC键（键码27）
             if (event.keyCode === 27) {
                this.exit();
            }
        },
        /**退出截屏 */
    exit(){
        let dom=document.getElementById('selectionOverlay');
        document.body.classList.remove('animation-paused');
                if(dom){
                    dom.style.display = 'none';
                    dom.style['clip-path']='none';
                    this.flag=false;
                    this.canvas.addEventListener('mousedown',this.bindStartDrag);
                    this.canvas.addEventListener('mousemove',this.bindDraging);
                    this.canvas.addEventListener('mouseup',this.bindEndDrag);
                    this.canvas&&document.body.removeChild(this.canvas);
                    this.previewCanvas&&document.body.removeChild(this.previewCanvas);
                    this.currentTool='';
                }
    },
    },
    mounted(){
        this.selectionOverlay=document.getElementById('selectionOverlay');
        this.selectionBox=document.getElementById('selectionBox');
        this.selectionInfo=document.getElementById('selectionInfo');
        document.addEventListener('keydown',this.exitScreen);
    },
    destroyed(){
        document.removeEventListener('keydown',this.exitScreen);
        this.endListener();
    }
}
</script>

<style lang="less" scoped>
.active{
    color: var(--blue);
    font-weight: 700;
}
.icon-jiequpingmu {
  position: fixed;
  right: 5rem;
  bottom: 10rem;
  color:#ffffff ;
  cursor: pointer;
  z-index: 998;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: rgba(204, 204, 204, .8);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:2.3rem ;
}
#selectionOverlay {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    // background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: none;
    cursor: default;
}

#selectionBox {
    position: absolute;
    border: 2px dashed #f1c40f;
    // background-color: rgba(241, 196, 15, 0.1);
    display: none;
}
.tool-box{
        position: fixed;
        padding:0.5rem 1rem;
        background-color: #ffffff;
        color: #3F3F3F;
        font-size: 2rem;
        border-radius: 0.5rem;
        z-index: 999999;
        &> :nth-child(n){
            margin-left: 1rem;
            cursor: pointer;
        }
        &> :nth-child(1){
            margin-left: 0;
        }
    }
.selection-info {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    pointer-events: none;
    z-index: 1001;
}
.print-screen{
    height: 0;
}
.icon-gou{
    color: #67c23a;
}
.icon-guanbi{
    color: red;
}
</style>